import axios from 'axios';

import WAVELIGHT_URL from './url';

import { getAuthToken } from '../../utils';

export const doLoginRequest = async (username: string, password: string) => {
  const response = await axios.post(
    `${WAVELIGHT_URL}/login/`,
    {
      username,
      password,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
  return response.data;
};

export const doRegistrationRequest = async (
  username: string,
  email: string,
  password: string,
  pin: string,
) => {
  const response = await axios.post(
    `${WAVELIGHT_URL}/register/`,
    {
      username,
      email,
      password,
      pin,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
  return response.data;
};

export const doGetUserProfile = async () => {
  const token = getAuthToken();
  const response = await axios.get(`${WAVELIGHT_URL}/profile/`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};
